'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('@ali/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./index.styl');

var _get_locale = require('@ali/brokkoli/lib/utils/get_locale');

var _get_locale2 = _interopRequireDefault(_get_locale);

var _log = require('@ali/log');

var _log2 = _interopRequireDefault(_log);

var _resource = require('@ali/resource');

var _resource2 = _interopRequireDefault(_resource);

var _broccoliCmpImgframe = require('@ali/broccoli-cmp-imgframe');

var _broccoliCmpImgframe2 = _interopRequireDefault(_broccoliCmpImgframe);

var _removePrefixLoading = require('@ali/unit/utils/removePrefixLoading');

var _removePrefixLoading2 = _interopRequireDefault(_removePrefixLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loading = function (_Component) {
  _inherits(Loading, _Component);

  function Loading(props) {
    _classCallCheck(this, Loading);

    var _this = _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).call(this, props));

    _log2.default.loading();
    _this.state = {};
    _this.cb = _this.cb.bind(_this);
    return _this;
  }

  _createClass(Loading, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initPg();
    }
  }, {
    key: 'initPg',
    value: function initPg() {
      var _this2 = this;

      _resource2.default.loadResource(this.props.srcs || [], function () {
        _log2.default.ready();
        setTimeout(function () {
          _this2.setState({ beLoad: true });
        }, 0);
      }, function (per) {
        _this2.setState({
          per: Math.floor(per * 100) + '%'
        });
      });
    }
  }, {
    key: 'cb',
    value: function cb() {
      (0, _removePrefixLoading2.default)();
    }
  }, {
    key: 'renderImgFrame',
    value: function renderImgFrame() {
      var _props = this.props,
          img = _props.img,
          ratio = _props.ratio,
          num = _props.num,
          frameArr = _props.frameArr,
          width = _props.width,
          height = _props.height,
          timeHack = _props.timeHack;

      return _react2.default.createElement(_broccoliCmpImgframe2.default, {
        img: window.__PREFIX_LOADING_IMG__ || img,
        ratio: ratio,
        num: num,
        frameArr: frameArr,
        width: width,
        height: height,
        timeHack: timeHack,
        cb: this.cb
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var beLoad = this.state.beLoad;
      var _props2 = this.props,
          strLoad = _props2.strLoad,
          colorFont = _props2.colorFont,
          colorBg = _props2.colorBg,
          debug = _props2.debug;

      if (!beLoad || debug) {
        return _react2.default.createElement(
          'div',
          { className: 'cmp-loading', style: {
              background: colorBg
            } },
          _react2.default.createElement(
            'dl',
            null,
            _react2.default.createElement(
              'dt',
              null,
              this.renderImgFrame()
            ),
            _react2.default.createElement(
              'dd',
              { style: { color: colorFont } },
              (0, _get_locale2.default)(strLoad)
            ),
            _react2.default.createElement(
              'dd',
              { style: { color: colorFont } },
              this.state.per !== 0 ? this.state.per : null
            )
          )
        );
      }
      return this.props.children || null;
    }
  }]);

  return Loading;
}(_react.Component);

Loading.propTypes = {
  /**
   * @title 加载文案,支持巴别塔
   */
  strLoad: _propTypes2.default.string,
  /**
   * @title 序列帧loading图
   */
  // img: PropTypes.imgUrlString,
  img: _propTypes2.default.string,
  /**
   * @title 以倍数增加减少动画周期时间
   */
  ratio: _propTypes2.default.number,
  /**
   * @title 帧数
   */
  num: _propTypes2.default.number,
  /**
   * @title 帧数组，帧标示最小从1开始以逗号隔开
   */
  frameArr: _propTypes2.default.string,
  /**
   * @title 文字颜色
   */
  colorFont: _propTypes2.default.string,
  /**
   * @title 背景颜色
   */
  colorBg: _propTypes2.default.string,
  /**
   * @title 预加载图片资源
   */
  // srcs: PropTypes.imgArray,
  srcs: _propTypes2.default.arrayOf(_propTypes2.default.string),
  /**
   * @title img width(非必须)
   */
  width: _propTypes2.default.number,
  /**
   * @title img height(非必须)
   */
  height: _propTypes2.default.number,
  /**
   * @title 图片加载成功后延迟操作，毫秒（非必填）
   */
  timeHack: _propTypes2.default.number
};
Loading.defaultProps = {
  strLoad: 'loading.text',
  img: '//img.ucweb.com/s/uae/g/1y/broccoli/iplact/stepsall/resources/png/loading.e1b36e67c170e9ea5e91e9631bd04569.png',
  // img: require('./football_wait.png'),
  // img: require('./test_img/loading.png'),
  num: 11,
  ratio: 1,
  // num: 6,
  // frameArr: '1,2,3,4',
  colorFont: '#feb100',
  colorBg: '#fff',
  srcs: [
    // '//img.ucweb.com/s/uae/g/0n/guanjunshiwole0518.png',
    // '//img.ucweb.com/s/uae/g/0n/ipl420180517en.png',
    // require('./football_wait.png'),
  ]
};
exports.default = Loading;